/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import { NavbarV2 as Nav } from '@bitcoin-portal/navbar';
import { Helmet } from 'react-helmet';
import PropTypes from 'prop-types';
import { HeadSection } from './styled';
import SEO from '../../components/SEO';
import Header from './Header';
import BuySellTrade from './BuySellTrade';
import ERC from './ERC';
import MoveMoney from './MoveMoney';
import Markets from './Markets';
import Manage from './Manage';
import Security from './Security';
import GetStarted from './GetStarted';
import Subscribe from '../../components/Subscribe';
import { appLocales } from '../../i18n';
import WalletsCreated from './WalletsCreated';
import Rewards from './Rewards';
import Features from './Features/Features';
import NavbarHome from '../../components/NavbarHome/NavbarHome';
import Footer from '../../components/Footer/Footer';
import { useBranchLink } from '../../helpers/branchLink';
import FloatingQRIcon from '../../components/FloatingQRIcon';

const Home = ({ locale }) => {
  const { messages } = useIntl();
  const mobileButtonLink = useBranchLink({
    branch: messages['home.header.link.mobile_button'],
    android: messages['home.header.link.googleplay'],
    iOS: messages['home.header.link.appstore'],
    fallback: messages['home.header.link.mobile_button'],
  });

  const branchLink = messages['home.header.link.mobile_button'];

  return (
    <>
      <Helmet>
        <script
          src={
            process.env.MPC_WIDGET_URL ||
            'https://widget.bitcoin.com/widget.v0.7.14.iife.js'
          }
          type="text/javascript"
        />
        <link
          rel="preconnect"
          href="https://fonts.bitcoin.com/Elza/Elza_Condensed_Black/crossmedia/Elza-CondensedBlack.woff"
          as="font"
          type="font/woff"
          crossOrigin="anonymous"
        />
        <link
          rel="preconnect"
          href="https://fonts.bitcoin.com/Satoshi_Variable/Fonts/WEB/fonts/Satoshi-Medium.woff"
          as="font"
          type="font/woff"
          crossOrigin="anonymous"
        />
        <link
          rel="preconnect"
          href="https://fonts.bitcoin.com/Chivo_Mono/ChivoMono-VariableFont_wght.ttf"
          as="font"
          type="font/ttf"
          crossOrigin="anonymous"
        />
        <link
          href="https://fonts.googleapis.com/css2?family=Noto+Sans+JP:wght@500..900&family=Noto+Sans:ital,wdth,wght@0,75..100,500..900;1,62.5..100,500..900&display=swap"
          rel="stylesheet"
          key="google-fonts2"
        />

        <style>
          {`
            @font-face {
              font-family: 'Elza Condensed';
              src: url('https://fonts.bitcoin.com/Elza/Elza_Condensed_Black/crossmedia/Elza-CondensedBlack.woff') format('woff');
              font-style: normal;
              font-display: swap;
            }
            @font-face {
              font-family: 'Satoshi Variable Medium';
              src: url('https://fonts.bitcoin.com/Satoshi_Variable/Fonts/WEB/fonts/Satoshi-Medium.woff') format('woff');
              font-weight: normal;
              font-style: normal;
              font-display: swap;
            }
            @font-face {
              font-family: 'Chivo Mono';
              src: url('https://fonts.bitcoin.com/Chivo_Mono/ChivoMono-VariableFont_wght.ttf') format('truetype');
              font-weight: normal;
              font-style: normal;
              font-display: swap;
            }
          `}
        </style>
      </Helmet>
      <SEO page="home" />
      <NavbarHome locale={locale} />
      <Header locale={locale} />
      {/* <WalletsCreated /> */}
      <Features locale={locale} />
      <Rewards locale={locale} mobileButtonLink={mobileButtonLink} />
      <GetStarted locale={locale} />
      <Subscribe />
      <Footer />
      <FloatingQRIcon branchLink={branchLink} />
    </>
  );
};
Home.propTypes = {
  locale: PropTypes.string.isRequired,
};

export default Home;
